import { Component, OnInit } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { ConsentRefusalSuspension } from '@Models';
import { PatientService } from '@Services';
import { Router } from '@angular/router';
import { AsyncPipe, DatePipe } from '@angular/common';
import { ErrorSummaryComponent } from '../../error-summary/error-summary.component';
import { LoadingSpinnerComponent } from '../../loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-vaccine-not-given',
  imports: [AsyncPipe, DatePipe, ErrorSummaryComponent, LoadingSpinnerComponent],
  templateUrl: './vaccine-not-given.component.html',
  styleUrl: './vaccine-not-given.component.css',
})
export class VaccineNotGivenComponent implements OnInit {
  nhsNumber: string | null = null;
  consentRefusal$: Observable<ConsentRefusalSuspension[] | null> | null = null;
  consentRefusalData: ConsentRefusalSuspension[] = [];
  errorMessage: string | null = null;
  errorStatus: string | null = null;

  constructor(
    private _patientService: PatientService,
    private _router: Router,
  ) {}

  ngOnInit() {
    const urlSegments = this._router.url.split('/');
    if (urlSegments.length > 2) {
      this.nhsNumber = urlSegments[urlSegments.length - 2];
      this.loadConsentRefusalSuspensionData();
      this.consentRefusal$?.subscribe((res) => console.log(res));
    }
  }

  private loadConsentRefusalSuspensionData() {
    if (this.nhsNumber) {
      this.consentRefusal$ = this._patientService.consentRefusalSuspension(this.nhsNumber).pipe(
        catchError((error) => {
          if (error.status === 404) {
            this.errorMessage = 'The child has no information recorded in this section.';
            this.errorStatus = '404';
          } else {
            this.errorMessage = 'An error occurred while fetching childhood vaccination data.';
          }
          return of(null);
        }),
      );

      this.consentRefusal$.subscribe((data) => {
        if (data) {
          try {
            this.consentRefusalData = data.sort(
              (a, b) => new Date(a.consentDate).getTime() - new Date(b.consentDate).getTime(),
            );
          } catch (e) {
            console.error('Error parsing consent refusal suspension data:', e);
          }
        }
      });
    }
  }
}
